import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import qs from 'qs';
import ReactTooltip from 'react-tooltip'
import Loader from '../components/Loader';
import sunwayPalLogo from '../images/sunway_pal.png'

class SunwayPal extends Component {

    constructor(props) {
        super(props);
        const { location } = props;
        let cardId = ''
        let loading = false;
        let added = false;
        let alreadyAdded = false;
        let errorMsg;
        let email = ''

        if(location.search){
            const qsparse = qs.parse(location.search.substr(1));
            email = qsparse.email
        }

        this.state = {
            cardId,
            loading,
            added,
            alreadyAdded,
            errorMsg,
            orderName: props.params.gtrid,
            email
        };
    }

    componentWillMount(){
    }

    componentDidMount() {
        const { params: { gtrid }, location: {query: {value}} } = this.props;
    }

    handleAddPoints = () => {

        const { params: { gtrid }, location: {query: {value}} } = this.props;
        let { cardId } = this.state;
        this.setState({ loading: true });

        return api('/api/sunwaypal/add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                card_id : cardId,
                gtr_id: gtrid,
                purchase_amount: value
            })
        }).then(result => {

            this.setState({ loading: false });

            if(result && !result.error){
                error: null,
                this.setState({ added: true });
            } else if(result.error){
                this.setState({ errorMsg: result.error,
                    alreadyAdded: false
                });
            } else {
                this.setState({
                    error: null,
                    alreadyAdded: true
                 });
            }
        })
    }

    handleCardIdChange = (event) => {
        this.setState({ cardId: event.target.value });
    }

    render() {
        const { error } = this.props
        const { cardId, loading, added, alreadyAdded, errorMsg, orderName, email } = this.state;

        return (
            <div className="sunwaypal-wrapper" style={{height: '150px'}}>
                <div >
                    <div className="row sunwaypal-row-wrapper">
                        <div className="col-lg-12">
                            <div>
                                {
                                    error &&
                                    <Alert bsStyle="danger">
                                        <div>{error}</div>
                                    </Alert>
                                }
                                {/* <img className="sunway-pal-logo" src={sunwayPalLogo} alt="sunway pal" height="40px"/> */}
                                {/* <label className="sunway-pal-label">Collection for Sunway Pals Points</label> */}
                                {/* <div>
                                    <div className="form-group">
                                            <input type="radio" name="type" value="sunway_pals_card"/> Sunway Pals Card No
                                            <input className="sunway-radio" type="radio" name="type" value="member_id"/> Sunway Pals Member ID
                                    </div>
                                </div>                */}
                                {/* <div className="row"> */}
                                {/*     <div className="col-xs-9"> */}
                                {/*         <div className="form-group"> */}
                                {/*             <input data-tip="Sunway Pals Card Number or Member ID has 16-digit available on the back of your Sunway Pals card or mobile app" className="form-control" placeholder="Sunway Pals Card No / Member ID" type="text" maxLength="16" onChange={this.handleCardIdChange}/> */}
                                {/*             <ReactTooltip class="sunway-tooltip" place="top" type="dark" effect="solid"/> */}
                                {/*             <span className="sunway-signup">Not a Sunway Pals member yet? Sign up <a href="https://member.sunwaypals.com.my/sign_up" target="_blank">here</a>.</span> */}
                                {/*         </div> */}
                                {/*     </div> */}
                                {/*     <div className="col-xs-3"> */}
                                {/*         <Button disabled={added || !cardId || cardId.length !== 16} className="btn-postcode-checker" onClick={this.handleAddPoints} block>{added ? 'Submitted' : 'Submit'}</Button> */}
                                {/*     </div> */}
                                {/* </div> */}
                                {/* { */}
                                {/*     loading && */}
                                {/*     <Loader /> */}
                                {/* } */}
                                {/* { */}
                                {/*     alreadyAdded && */}
                                {/*     <p className="sunwaypal-error">The Points have been collected previously, please contact support@giftr.my for further assistance</p> */}
                                {/* } */}
                                {/* { */}
                                {/*     errorMsg && */}
                                {/*     <p className="sunwaypal-error">{errorMsg}</p> */}
                                {/* } */}
                                {/* { */}
                                {/*     added && */}
                                {/*     <p className="sunwaypal-success">Thanks for your submission. Sunway Pals Points will be awarded to your account within 14 working days. For queries, please write to support@giftr.my</p> */}
                                {/* } */}
                                {/* <hr/> */}
                                <div className="row" style={{marginTop: '40px'}}>
                                    <div className="col-xs-8">
                                        Click here to view the updated delivery status for your order.
                                    </div>
                                    <div className="col-xs-4">
                                        <a className="btn-postcode-checker btn btn-default btn-block" target="_blank" href={`https://giftr.my/pages/track-order-thank-you?utm_source=thank-you-page&utm_medium=iframe-widget&utm_campaign=self-serve-order-tracking&email=${email}&order_name=${orderName}`}>Order Tracking Page</a>
                                    </div>
                                </div>
                                <hr/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {

    return {

    };
})(SunwayPal);
